import graphqlClient from "../utils/graphql_client_util";

const QUERIES = {
  CATEGORY_LIST: `
    query CategoryList($input: CategorySearchInput!) {
      categoryList(input: $input) {
        totalPages
        totalElements
        success
        size
        page
        error {
          code
          errorType
          message
        }
        data {
          type
          title
          regName
          regDate
          order
          modName
          modDate
          color
          files {
            s3key
          }
          categorySeq
        }
      }
    }
  `,

  SEARCH_DAILY_QUIZ: `
    query SearchDailyQuiz($input: QuizSearchInput!) {
      searchDailyQuiz(input: $input) {
        totalPages
        totalElements
        success
        size
        page
        error {
          code
          errorType
          message
        }
        data {
          userAnswers {
            answer
            regDate
            userName
            userSeq
          }
          title
          regName
          regDate
          quizSeq
          questionDate
          question
          orderQuestion
          modName
          modDate
          files {
            s3key
          }
          categoryTitle
          categorySeq
          categoryColor
          answer
        }
      }
    }
  `,

  SEARCH_DETAIL_DAILY_QUIZ: `
    query SearchDetailDailyQuiz($quizSeq: Int!) {
      searchDetailDailyQuiz(quizSeq: $quizSeq) {
        success
        error {
          errorType
          message
          code
        }
        data {
          title
          userAnswers {
            userSeq
            userName
            regDate
            answer
          }
          regName
          regDate
          quizSeq
          questionDate
          question
          orderQuestion
          modName
          modDate
          files {
            s3key
          }
          categoryTitle
          categorySeq
          categoryColor
          answer
        }
      }
    }
  `,
};

/**
 * 브레인랩 카테고리 목록 조회
 * codeType / type은 DAILY_QUESTION 고정
 */
export const getCategoryList = async () => {
  try {
    const data = await graphqlClient.query(
      QUERIES.CATEGORY_LIST,
      {
        input: {
          codeType: "TYPES",
          type: "DAILY_QUESTION",
        },
      },
      { useAuth: false }
    );

    if (data.categoryList.success) {
      return {
        success: true,
        data: data.categoryList.data || [],
        totalPages: data.categoryList.totalPages,
        totalElements: data.categoryList.totalElements,
        page: data.categoryList.page,
        size: data.categoryList.size,
      };
    } else {
      return {
        success: false,
        error: data.categoryList.error,
      };
    }
  } catch (err) {
    console.error("Error fetching category list:", err);
    return {
      success: false,
      error: {
        message: "카테고리 목록을 불러오는데 실패했습니다.",
        errorType: "NETWORK_ERROR",
      },
    };
  }
};

/**
 * 데일리 퀴즈(브레인랩) 목록 조회
 * @param {number|string|null} categorySeq - null/빈 값이면 전체 조회
 * @param {number} page - 0-based
 * @param {number} size
 */
export const searchDailyQuiz = async (categorySeq = null, page = 0, size = 12) => {
  try {
    // 오늘 날짜(yyyy-MM-dd) — 항상 startDate로 전달
    const now = new Date();
    const startDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

    const input = { page, size, startDate };

    // "전체"가 아닌 경우에만 categorySeq 전달
    if (categorySeq !== null && categorySeq !== "" && categorySeq !== undefined) {
      input.categorySeq = parseInt(categorySeq, 10);
    }

    const data = await graphqlClient.query(
      QUERIES.SEARCH_DAILY_QUIZ,
      { input },
      { useAuth: false }
    );

    if (data.searchDailyQuiz.success) {
      return {
        success: true,
        data: data.searchDailyQuiz.data || [],
        totalPages: data.searchDailyQuiz.totalPages,
        totalElements: data.searchDailyQuiz.totalElements,
        page: data.searchDailyQuiz.page,
        size: data.searchDailyQuiz.size,
      };
    } else {
      return {
        success: false,
        error: data.searchDailyQuiz.error,
      };
    }
  } catch (err) {
    console.error("Error fetching daily quiz list:", err);
    return {
      success: false,
      error: {
        message: "브레인랩 목록을 불러오는데 실패했습니다.",
        errorType: "NETWORK_ERROR",
      },
    };
  }
};

/**
 * 데일리 퀴즈 상세 조회 (상세 모달용)
 * @param {number|string} quizSeq
 */
export const searchDetailDailyQuiz = async (quizSeq) => {
  try {
    const data = await graphqlClient.query(
      QUERIES.SEARCH_DETAIL_DAILY_QUIZ,
      { quizSeq: parseInt(quizSeq, 10) },
      { useAuth: false }
    );

    if (data.searchDetailDailyQuiz.success) {
      return {
        success: true,
        data: data.searchDetailDailyQuiz.data,
      };
    } else {
      return {
        success: false,
        error: data.searchDetailDailyQuiz.error,
      };
    }
  } catch (err) {
    console.error("Error fetching daily quiz detail:", err);
    return {
      success: false,
      error: {
        message: "상세 내용을 불러오는데 실패했습니다.",
        errorType: "NETWORK_ERROR",
      },
    };
  }
};
